<template>
    <v-row>     
      <div class="col-md-12 home-box">
        <Breadcrumbs :title="'Users'"></Breadcrumbs>
        <EmployerGrid></EmployerGrid>
      </div>
      <div class="col-md-12 home-tabs-body">
      </div>
    </v-row>
  </template>
  
  <script>
  
  import EmployerGrid from "@/components/employers/EmployerGrid";
  import { createNamespacedHelpers } from "vuex";
  import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  export default {
    name: "Employers",
    components: {
      EmployerGrid,
      Breadcrumbs
    },
    data: function () {
      return {
      };
    },
    computed: {
      ...mapGetters({
        loading: "loading",
        profile: "profile"
      })
    },
    mounted() {
      this.$store.dispatch("auth/getProfile");
    },
  
    watch: {
  
    },
  
    methods: {
  
    },
  
  };
  </script>